if (!customElements.get('m-cart-upsell-item')) {
  customElements.define(
    'm-cart-upsell-item',
    class MCartUpsellItem extends HTMLElement {
      constructor() {
        super();
        this.variants = [];
        this.currentVariant = null;
        this.onChange = (event) => this.handleChange(event);
      }

      connectedCallback() {
        this.variantJsonEl = this.querySelector('[data-cart-upsell-variants]');
        this.selectEl = this.querySelector('[data-cart-upsell-select]');
        this.priceEl = this.querySelector('[data-cart-upsell-price]');
        this.currencyCode = this.dataset.currencyCode || window.Shopify?.currency?.active || 'USD';
        this.variants = this.getVariants();
        this.currentVariant = this.getInitialVariant();

        this.selectEl?.addEventListener('change', this.onChange);
        this.render();
      }

      disconnectedCallback() {
        this.selectEl?.removeEventListener('change', this.onChange);
      }

      getVariants() {
        try {
          return JSON.parse(this.variantJsonEl?.textContent || '[]');
        } catch (error) {
          console.error('MCartUpsellItem: variant JSON error', error);
          return [];
        }
      }

      getInitialVariant() {
        if (this.selectEl && !this.selectEl.value) return null;

        const selectedVariantId = Number(this.selectEl?.value || this.dataset.selectedVariantId || 0);

        return this.variants.find((variant) => variant.id === selectedVariantId) || (!this.selectEl ? this.variants[0] : null);
      }

      handleChange(event) {
        const selectedVariantId = Number(event.target?.value || 0);
        const selectedVariant = this.variants.find((variant) => variant.id === selectedVariantId);

        if (!selectedVariant) return;

        this.currentVariant = selectedVariant;
        this.render();
        this.dispatchVariantChange();
      }

      render() {
        if (this.priceEl && this.currentVariant?.price != null) {
          this.priceEl.textContent = this.currentVariant.priceFormatted || this.formatMoney(this.currentVariant.price);
        }
      }

      dispatchVariantChange() {
        this.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: {
              variant: this.currentVariant,
              options: this.currentVariant?.options || [],
            },
          }),
        );
      }

      formatMoney(cents) {
        if (typeof mProductBuyButtonFormatMoneyFromTheme === 'function') {
          return mProductBuyButtonFormatMoneyFromTheme(cents, this.currencyCode);
        }

        return String(new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currencyCode,
          minimumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
          maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
        }).format((Number(cents) || 0) / 100))
          .replace(/(?:\s|&nbsp;)*kr\.(?=<|$)/gi, 'kr')
          .replace(/(?:\s|&nbsp;)+kr(?=<|$)/gi, 'kr');
      }
    },
  );
}
